import { extend } from 'sk-ui/lib/utils/util.js'

import { action } from 'sky-engine/api'

import productForm from './metaData/productForm'

import { PRODUCT_MNG } from '@/api/apiModules'

export default {
  productCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: productForm,
      props
    })
  },
  productEdit({ commit }, params) {
    const props = {
      title: '编辑产品版本',
      params: {
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, productForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  },
  fetchProductFromYunZhi({ commit }, params) {
    params.viewController.loading = true
    action(PRODUCT_MNG, 'fetchProduct', {})
      .then(response => {
        params.viewController.loading = false
        this.dispatch('OpenNotification', { message: '同步产品版本信息成功', type: 'success' })
      })
      .catch(e => {
        params.viewController.loading = false
        throw e
      })
  }
}
